import styled from "styled-components";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { rawColors } from "../../../design-system/tokens/colors";

/**
 * Underlined text-link affordance used inside table rows for inline
 * actions (e.g. "View" / "Connect"). Mirrors Figma `--text/interactive`
 * by routing through `rawColors.primary[500]` (the design-system blue).
 */
export const LinkButton = styled.button`
  appearance: none;
  background: none;
  border: none;
  margin: 0;
  padding: 0;
  cursor: pointer;
  ${typographyMixin("body", 3)}
  color: ${rawColors.primary[500]};
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 2px;

  &:hover:not(:disabled) {
    color: ${rawColors.primary[600]};
  }

  &:focus-visible {
    outline: 2px solid ${rawColors.primary[500]};
    outline-offset: 2px;
    border-radius: 2px;
  }

  &:disabled {
    color: ${rawColors.text.lowEmphasis};
    cursor: not-allowed;
    text-decoration-color: ${rawColors.text.lowEmphasis};
  }
`;
